export default {"src":"/_next/static/media/mailbox-left.d9d6462b.svg","height":72,"width":72};